import React, { useEffect, useRef, useState, useContext } from "react";
import Button from "../components/elements/Button/Button";
import Logo from "../components/Common/Logo";
import "./LandingPage.css";
import Accordion from "../components/elements/Accordian/Accordian";
import Person from "../assets/Images/person.jpg";
import Webenza from "../assets/Images/webenza.jpg";
import eeezoLogo from "../assets/Images/eeezo_logo.png";
import eeezoHome from "../assets/Images/eeezoHome.png";
import eeezoJob from "../assets/Images/eeezoJob.png";
import jobpost from "../assets/Images/jobpost.png";
import eeezoTestimonial from "../assets/Images/eeezoTestimonial.png";
import fblogo from "../assets/Images/fblogo.png";
import instalogo from "../assets/Images/instalogo.png";
import linkedinlogo from "../assets/Images/linkedinlogo.png";
import twitterlogo from "../assets/Images/twitterlogo.png";
import youtubelogo from "../assets/Images/youtubelogo.png";
import locmarker from "../assets/Images/locmarker.png";
import phonelogo from "../assets/Images/phonelogo.png";
import maillogo from "../assets/Images/maillogo.png";
import { FaStar } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
const LandingPage = () => {
  const navigate = useNavigate();
  const { token } = useContext(AuthContext);
  const accordionData = [
    { title: "Complete Profile", content: "Content for section 1" },
    { title: "Discover Opportunities", content: "Content for section 2" },
    { title: "Apply for jobs", content: "Content for section 3" },
  ];
  const scrollRef = useRef(null);
  const scrollRefAI = useRef(null);
  const scrollJobs = useRef(null);
  const scrollReview = useRef(null);
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    const scrollRefAIContainer = scrollRefAI.current;
    const scrollSpeed = 1;
    let scrollPosition = 0;

    const autoScroll = () => {
      if (scrollContainer) {
        scrollPosition += scrollSpeed;
        if (
          scrollPosition >=
          scrollContainer.scrollWidth - scrollContainer.clientWidth
        ) {
          scrollPosition = 0;
        }
        scrollContainer.scrollLeft = scrollPosition;
      }
      if (scrollRefAIContainer) {
        scrollPosition += scrollSpeed;
        if (
          scrollPosition >=
          scrollRefAIContainer.scrollWidth - scrollRefAIContainer.clientWidth
        ) {
          scrollPosition = 0;
        }
        scrollRefAIContainer.scrollLeft = scrollPosition;
      }
    };

    const interval = setInterval(autoScroll, 20);

    return () => clearInterval(interval);
  }, []);
  const jobs = [
    {
      company: "Webenza India Pvt Ltd.",
      position: "Associate Sales Support Representative",
      salary: "₹ 65,000 - ₹ 85,000 / monthly",
      location: "Mumbai, India",
      image: Webenza,
    },
    {
      company: "Webenza India Pvt Ltd.",
      position: "Associate Sales Support Representative",
      salary: "₹ 65,000 - ₹ 85,000 / monthly",
      location: "Mumbai, India",
      image: Webenza,
    },
    {
      company: "Webenza India Pvt Ltd.",
      position: "Associate Sales Support Representative",
      salary: "₹ 65,000 - ₹ 85,000 / monthly",
      location: "Mumbai, India",
      image: Webenza,
    },
    {
      company: "Webenza India Pvt Ltd.",
      position: "Associate Sales Support Representative",
      salary: "₹ 65,000 - ₹ 85,000 / monthly",
      location: "Mumbai, India",
      image: Webenza,
    },
    {
      company: "Webenza India Pvt Ltd.",
      position: "Associate Sales Support Representative",
      salary: "₹ 65,000 - ₹ 85,000 / monthly",
      location: "Mumbai, India",
      image: Webenza,
    },
    {
      company: "Webenza India Pvt Ltd.",
      position: "Associate Sales Support Representative",
      salary: "₹ 65,000 - ₹ 85,000 / monthly",
      location: "Mumbai, India",
      image: Webenza,
    },
    {
      company: "Webenza India Pvt Ltd.",
      position: "Associate Sales Support Representative",
      salary: "₹ 65,000 - ₹ 85,000 / monthly",
      location: "Mumbai, India",
      image: Webenza,
    },
    {
      company: "Webenza India Pvt Ltd.",
      position: "Associate Sales Support Representative",
      salary: "₹ 65,000 - ₹ 85,000 / monthly",
      location: "Mumbai, India",
      image: Webenza,
    },
  ];

  const reviews = [
    {
      review:
        "Eeezo is a great platform for job seekers. It is easy to use and has a lot of job opportunities. I would recommend it to anyone looking for a job.",
      name: "John Doe",
      job: "HR Director @InfoTech",
      rating: 3,
    },
    {
      review:
        "Eeezo is a great platform for job seekers. It is easy to use and has a lot of job opportunities. I would recommend it to anyone looking for a job.",
      name: "John Doe",
      job: "HR Director @InfoTech",
      rating: 4,
    },
    {
      review:
        "Eeezo is a great platform for job seekers. It is easy to use and has a lot of job opportunities. I would recommend it to anyone looking for a job.",
      name: "John Doe",
      job: "HR Director @InfoTech",
      rating: 4,
    },
    {
      review:
        "Eeezo is a great platform for job seekers. It is easy to use and has a lot of job opportunities. I would recommend it to anyone looking for a job.",
      name: "John Doe",
      job: "HR Director @InfoTech",
      rating: 4,
    },
    {
      review:
        "Eeezo is a great platform for job seekers. It is easy to use and has a lot of job opportunities. I would recommend it to anyone looking for a job.",
      name: "John Doe",
      job: "HR Director @InfoTech",
      rating: 4,
    },
    {
      review:
        "Eeezo is a great platform for job seekers. It is easy to use and has a lot of job opportunities. I would recommend it to anyone looking for a job.",
      name: "John Doe",
      job: "HR Director @InfoTech",
      rating: 4,
    },
    {
      review:
        "Eeezo is a great platform for job seekers. It is easy to use and has a lot of job opportunities. I would recommend it to anyone looking for a job.",
      name: "John Doe",
      job: "HR Director @InfoTech",
      rating: 4,
    },
    {
      review:
        "Eeezo is a great platform for job seekers. It is easy to use and has a lot of job opportunities. I would recommend it to anyone looking for a job.",
      name: "John Doe",
      job: "HR Director @InfoTech",
      rating: 4,
    },
    {
      review:
        "Eeezo is a great platform for job seekers. It is easy to use and has a lot of job opportunities. I would recommend it to anyone looking for a job.",
      name: "John Doe",
      job: "HR Director @InfoTech",
      rating: 4,
    },
    {
      review:
        "Eeezo is a great platform for job seekers. It is easy to use and has a lot of job opportunities. I would recommend it to anyone looking for a job.",
      name: "John Doe",
      job: "HR Director @InfoTech",
      rating: 4,
    },
  ];

  const handleJobScroll = (direction) => {
    let scrollContainer = scrollJobs.current;
    let scrollSpeed = 300;

    if (!scrollContainer) return;

    scrollContainer.scrollBy({
      left: direction === "left" ? -scrollSpeed : scrollSpeed,
      behavior: "smooth",
    });
  };
  const [hoveredIndex, setHoveredIndex] = useState(0);
  const handleReviewScroll = (direction) => {
    let scrollContainer = scrollReview.current;
    let scrollSpeed = 500;

    if (!scrollContainer) return;

    scrollContainer.scrollBy({
      left: direction === "left" ? -scrollSpeed : scrollSpeed,
      behavior: "smooth",
    });

    setTimeout(() => {
      let visibleIndex = Math.floor(scrollContainer.scrollLeft / 180);
      setHoveredIndex(visibleIndex);
    }, 400);
  };

  return (
    <>
      <div className="">
        <div className="lg:flex py-3 px-2">
          <div>
            <img src={eeezoLogo} className="h-auto w-auto object-cover" />
          </div>
          <div className="mt-2 ml-auto flex inline-block lg:mt-0">
            <Button
              className="p-2 bg-white border-[#059669] px-3"
              onClick={() =>
                token != "" && token != undefined
                  ? navigate("/Dashboard")
                  : navigate("/SignIn")
              }
            >
              Sign in as a Recruiter
            </Button>
            <Button className="p-2 text-white ml-3 px-3">
              <a
                href={`${process.env.REACT_APP_FRONTEND_URL}/SignIn?t=js`}
                className="no-underline text-white"
                rel="noopener noreferrer"
              >
                Sign in as a Job Seeker
              </a>
            </Button>
          </div>
        </div>
        <div
          className="w-full rounded-xl p-2 h-[30vh] lg:h-[100vh] bg-center bg-cover bg-no-repeat"
          style={{ backgroundImage: `url(${eeezoHome})` }}
        >
          <div className="flex">
            <div className="w-1/2">
              <div className="ml-12 mt-4">
                <p className="lg:text-[56px] font-[600] mb-0">
                  Say helloo<span className="opacity-80 mb-0">o</span>
                  <span className="opacity-60 mb-0">o</span>
                  <span className="opacity-40 mb-0">o</span>
                </p>
                <p className="lg:text-[56px] font-[600]">
                  to{" "}
                  <span className="bg-gradient-to-r from-[#94E7F9] via-[#34D399] to-[#34D399] text-transparent bg-clip-text">
                    eeezo!
                  </span>
                </p>
              </div>
              <div className="ml-12 mt-4">
                <p className="text-xs handlee-regular lg:text-[18px] ">
                  Your talent and job hunt sidekick
                </p>
              </div>
            </div>

            <div className="w-1/3 ml-auto lg:mt-12">
              <p className="text-[8px] mb-0 lg:text-base font-[400] opacity-60">
                It’s your time to shine. With Eeezo, stand out and let top
                companies find you.
              </p>
              <p className="text-[8px] lg:text-base font-[400] opacity-60 mb-0">
                Zero stress, zero hassle—just opportunities tailored for you.
              </p>
              <p className="p-1 text-[10px] lg:text-lg mb-0 border-b-[#059669] border-b-2 inline-flex items-center items-end hover:cursor-pointer">
                Get Started
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                  className="w-6 h-6 ml-2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 12h16m-6-6l6 6m-6 6l6-6"
                  />
                </svg>
              </p>
            </div>
          </div>
        </div>

        <div className="p-4">
          <div className="lg:flex gap-4 items-center">
            <div className="w-full lg:w-1/4">
              <p className="mb-0">
                <span className="text-[#059669] font-medium">5000+</span>{" "}
                companies
              </p>
              <p>already trust us</p>
            </div>

            <div
              ref={scrollRef}
              className="overflow-x-auto whitespace-nowrap no-scrollbar"
            >
              <div className="p-2 flex gap-4">
                {[
                  "Honey Well",
                  "Alphabet",
                  "Tesla",
                  "Microsoft",
                  "Amazon",
                  "Netflix",
                  "Google",
                  "Meta",
                  "Adobe",
                  "Apple",
                  "IBM",
                  "Intel",
                  "Salesforce",
                  "Oracle",
                ].map((company, index) => (
                  <p key={index} className="px-4 py-2 bg-gray-100 rounded-md">
                    {company}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="p-4 relative">
          <div className="lg:flex">
            <div className="lg:w-1/2">
              <div className="flex bg-black mb-4 lg:absolute inline-block py-3 px-4 rounded-lg lg:top-96 lg:left-1/3 lg:ml-24 border-[#059669] border-2">
                <p className="mb-0  mr-2 font-[500] bg-gradient-to-r from-[#94E7F9] via-[#34D399] to-[#34D399] text-transparent bg-clip-text">
                  For Job Seekers
                </p>

                <label class="inline-flex items-center cursor-pointer">
                  <input type="checkbox" value="" class="sr-only peer" />
                  <div class="relative w-11 h-6 border-1 border-white bg-black peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600"></div>
                </label>

                <p className="mb-0  ml-2 bg-gradient-to-r from-[#94E7F9] via-[#34D399] to-[#34D399] text-transparent bg-clip-text">
                  For Recruiters
                </p>
              </div>
              <p className="mb-0 lg:text-5xl font-[600]">How Jobs Find You</p>
              <p className="mb-0 lg:text-5xl font-[600] bg-gradient-to-r from-[#94E7F9] via-[#34D399] to-[#34D399] text-transparent bg-clip-text">
                First On Eeezo?
              </p>
              <div className="mt-12 lg:w-9/12">
                <Accordion data={accordionData} />
              </div>
            </div>
            <div className="lg:w-1/2">
              <img
                src={jobpost}
                className="lg:w-3/4 h-auto object-cover ml-auto"
              />
            </div>
          </div>
        </div>

        <div className="mt-8">
          <div
            ref={scrollRefAI}
            className="flex items-center overflow-x-auto whitespace-nowrap no-scrollbar"
          >
            {[
              <p className="text-gray-400 font-[600] text-2xl mb-0">
                AI Precision{" "}
                <span className="text-2xl text-black font-[600] ml-2">
                  Job Satisfaction
                </span>
                <span className="text-2xl font-[600] bg-gradient-to-r from-[#94E7F9] via-[#34D399] to-[#34D399] text-transparent bg-clip-text ml-4">
                  X
                </span>
              </p>,
              <p className="text-black font-[600] text-2xl mb-0">
                AI Precision{" "}
                <span className="text-2xl text-gray-600 font-[600] ml-2">
                  Job Satisfaction
                </span>
                <span className="text-2xl font-[600] bg-gradient-to-r from-[#94E7F9] via-[#34D399] to-[#34D399] text-transparent bg-clip-text ml-4">
                  X
                </span>
              </p>,
              <p className="text-gray-400 font-[600] text-2xl mb-0">
                AI Precision{" "}
                <span className="text-2xl text-black font-[600] ml-2">
                  Job Satisfaction
                </span>
                <span className="text-2xl font-[600] bg-gradient-to-r from-[#94E7F9] via-[#34D399] to-[#34D399] text-transparent bg-clip-text ml-4">
                  X
                </span>
              </p>,
              <p className="text-black font-[600] text-2xl mb-0">
                AI Precision{" "}
                <span className="text-2xl text-gray-600 font-[600] ml-2">
                  Job Satisfaction
                </span>
                <span className="text-2xl font-[600] bg-gradient-to-r from-[#94E7F9] via-[#34D399] to-[#34D399] text-transparent bg-clip-text ml-4">
                  X
                </span>
              </p>,
              <p className="text-gray-400 font-[600] text-2xl mb-0">
                AI Precision{" "}
                <span className="text-2xl text-black font-[600] ml-2">
                  Job Satisfaction
                </span>
                <span className="text-2xl font-[600] bg-gradient-to-r from-[#94E7F9] via-[#34D399] to-[#34D399] text-transparent bg-clip-text ml-4">
                  X
                </span>
              </p>,
              <p className="text-black font-[600] text-2xl mb-0">
                AI Precision{" "}
                <span className="text-2xl text-gray-600 font-[600] ml-2">
                  Job Satisfaction
                </span>
                <span className="text-2xl font-[600] bg-gradient-to-r from-[#94E7F9] via-[#34D399] to-[#34D399] text-transparent bg-clip-text ml-4">
                  X
                </span>
              </p>,
              <p className="text-gray-400 font-[600] text-2xl mb-0">
                AI Precision{" "}
                <span className="text-2xl text-black font-[600] ml-2">
                  Job Satisfaction
                </span>
                <span className="text-2xl font-[600] bg-gradient-to-r from-[#94E7F9] via-[#34D399] to-[#34D399] text-transparent bg-clip-text ml-4">
                  X
                </span>
              </p>,
              <p className="text-black font-[600] text-2xl mb-0">
                AI Precision{" "}
                <span className="text-2xl text-gray-600 font-[600] ml-2">
                  Job Satisfaction
                </span>
                <span className="text-2xl font-[600] bg-gradient-to-r from-[#94E7F9] via-[#34D399] to-[#34D399] text-transparent bg-clip-text ml-4">
                  X
                </span>
              </p>,
              <p className="text-gray-400 font-[600] text-2xl mb-0">
                AI Precision{" "}
                <span className="text-2xl text-black font-[600] ml-2">
                  Job Satisfaction
                </span>
                <span className="text-2xl font-[600] bg-gradient-to-r from-[#94E7F9] via-[#34D399] to-[#34D399] text-transparent bg-clip-text ml-4">
                  X
                </span>
              </p>,
              <p className="text-black font-[600] text-2xl mb-0">
                AI Precision{" "}
                <span className="text-2xl text-gray-600 font-[600] ml-2">
                  Job Satisfaction
                </span>
                <span className="text-2xl font-[600] bg-gradient-to-r from-[#94E7F9] via-[#34D399] to-[#34D399] text-transparent bg-clip-text ml-4">
                  X
                </span>
              </p>,
              <p className="text-gray-400 font-[600] text-2xl mb-0">
                AI Precision{" "}
                <span className="text-2xl text-black font-[600] ml-2">
                  Job Satisfaction
                </span>
                <span className="text-2xl font-[600] bg-gradient-to-r from-[#94E7F9] via-[#34D399] to-[#34D399] text-transparent bg-clip-text ml-4">
                  X
                </span>
              </p>,
              <p className="text-black font-[600] text-2xl mb-0">
                AI Precision{" "}
                <span className="text-2xl text-gray-600 font-[600] ml-2">
                  Job Satisfaction
                </span>
                <span className="text-2xl font-[600] bg-gradient-to-r from-[#94E7F9] via-[#34D399] to-[#34D399] text-transparent bg-clip-text ml-4">
                  X
                </span>
              </p>,
              <p className="text-gray-400 font-[600] text-2xl mb-0">
                AI Precision{" "}
                <span className="text-2xl text-black font-[600] ml-2">
                  Job Satisfaction
                </span>
                <span className="text-2xl font-[600] bg-gradient-to-r from-[#94E7F9] via-[#34D399] to-[#34D399] text-transparent bg-clip-text ml-4">
                  X
                </span>
              </p>,
              <p className="text-black font-[600] text-2xl mb-0">
                AI Precision{" "}
                <span className="text-2xl text-gray-600 font-[600] ml-2">
                  Job Satisfaction
                </span>
                <span className="text-2xl font-[600] bg-gradient-to-r from-[#94E7F9] via-[#34D399] to-[#34D399] text-transparent bg-clip-text ml-4">
                  X
                </span>
              </p>,
            ].map((company, index) => (
              <p key={index} className="px-2 py-2">
                {company}
              </p>
            ))}
          </div>
        </div>

        <div className="lg:mt-24 px-2">
          <div
            className="w-full h-auto md:h-[70vh] lg:h-screen bg-center bg-cover bg-no-repeat rounded-xl flex flex-col items-center justify-center px-4 py-6"
            style={{ backgroundImage: `url(${eeezoJob})` }}
          >
            <div className="w-full lg:w-1/2 text-center">
              <p className="text-2xl md:text-3xl lg:text-5xl font-semibold">
                Why{" "}
                <span className="bg-gradient-to-r from-[#94E7F9] via-[#34D399] to-[#34D399] text-transparent bg-clip-text">
                  Choose Us
                </span>
              </p>
              <p className="text-sm md:text-base lg:text-lg mt-2">
                Real connections, real opportunities. Job seekers find their
                dream roles, recruiters find their ideal candidates – we make it
                all happen.
              </p>
            </div>

            <div className="flex flex-col md:flex-row gap-4 md:gap-6 justify-center mt-6 w-full px-2">
              <div className="bg-opacity-20 bg-[#8F86C312] p-4 md:p-6 rounded-xl border-2 border-white w-full md:w-1/3 ">
                <img
                  src={Person}
                  className="w-10 h-10 md:w-12 md:h-12  object-cover rounded-lg"
                />
                <p className="font-semibold text-sm md:text-lg mt-2">
                  AI-Powered Matching
                </p>
                <p className="text-sm font-[400]">
                  Our intelligent AI analyses skills and experience to connect
                  you with the most relevant opportunities, saving you time and
                  effort.
                </p>
              </div>
              <div className="bg-opacity-20 bg-[#8F86C312] p-4 md:p-6 rounded-xl border-2 border-white w-full md:w-1/3 ">
                <img
                  src={Person}
                  className="w-10 h-10 md:w-12 md:h-12  object-cover rounded-lg"
                />
                <p className="font-semibold text-sm md:text-lg mt-2">
                  Personalised Experience
                </p>
                <p className="text-sm font-[400]">
                  Our cutting-edge platform gives you exclusive access to a
                  curated talent pool and makes tailored job recommendations.
                </p>
              </div>
              <div className="bg-opacity-20 bg-[#8F86C312] p-4 md:p-6 rounded-xl border-2 border-white w-full md:w-1/3 ">
                <img
                  src={Person}
                  className="w-10 h-10 md:w-12 md:h-12  object-cover rounded-lg"
                />
                <p className="font-semibold text-sm md:text-lg mt-2">
                  Real-Time Updates
                </p>
                <p className="text-sm font-[400]">
                  Expect ultimate transparency. Track application status, get
                  instant notifications, and stay informed throughout the talent
                  and job hunt process.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="p-4 mt-24 grid gap-12">
          <div className="flex flex-col md:flex-row md:items-center justify-between">
            <div>
              <p className="font-semibold text-2xl md:text-3xl">
                Featured{" "}
                <span className="bg-gradient-to-r from-[#94E7F9] via-[#34D399] to-[#34D399] text-transparent bg-clip-text">
                  Jobs
                </span>
              </p>
              <p className="text-sm md:text-base text-gray-500">
                Ready for a change? Browse our hand-picked opportunities for you
                and apply now.
              </p>
            </div>

            <div className="flex gap-3 mt-4 md:mt-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="#059669"
                className="w-10 h-10 p-2 bg-[#F2F9F9] rounded-md rotate-180 hover:cursor-pointer"
                onClick={() => handleJobScroll("left")}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 12h16m-6-6l6 6m-6 6l6-6"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="#059669"
                className="w-10 h-10 p-2 bg-[#F2F9F9] rounded-md hover:cursor-pointer"
                onClick={() => handleJobScroll("right")}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 12h16m-6-6l6 6m-6 6l6-6"
                />
              </svg>
            </div>
          </div>

          <div
            ref={scrollJobs}
            className="overflow-x-auto no-scrollbar h-auto pb-2"
          >
            <div className="flex gap-4">
              {jobs.map((job, index) => (
                <div
                  key={index}
                  className="p-4 shadow-md rounded-lg w-full md:w-1/3 lg:w-1/4 grid gap-4 min-w-[280px] bg-white"
                >
                  <img
                    src={job.image}
                    className="w-12 h-12 border rounded-xl"
                    alt={job.company}
                  />

                  <div className="border-b-2 border-gray-200 pb-2">
                    <p className="font-normal text-sm text-gray-400">
                      {job.company}
                    </p>
                    <p className="font-semibold text-base">{job.position}</p>
                  </div>

                  <div>
                    <p className="text-xs font-normal text-gray-400">
                      {job.salary}
                    </p>
                    <p className="text-xs font-normal text-gray-400 flex items-center">
                      {job.location}
                      <span className="p-2 bg-[#F2F9F9] text-[#059669] text-xs ml-2 cursor-pointer rounded-md">
                        View Maps
                      </span>
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex justify-center">
            <p className="p-1 border-b-[#059669] border-b-2 inline-flex items-center text-[#059669] text-sm md:text-base hover:cursor-pointer">
              View More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className="w-6 h-6 ml-2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 12h16m-6-6l6 6m-6 6l6-6"
                />
              </svg>
            </p>
          </div>
        </div>

        <div
          className="p-6 md:p-8 mt-24 h-auto bg-center bg-contain bg-no-repeat rounded-xl"
          style={{
            backgroundImage: `url(${eeezoTestimonial})`,
            backgroundSize: "100% auto",
          }}
        >
          <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-6 md:gap-12 mt-6 md:mt-12">
            <p className="text-2xl md:text-3xl font-semibold text-center md:text-left">
              Real Results,{" "}
              <span className="bg-gradient-to-r from-[#94E7F9] via-[#34D399] to-[#34D399] text-transparent bg-clip-text">
                Real People
              </span>
            </p>
            <p className="text-sm md:text-base text-gray-500 text-center md:text-left">
              Don't just take our word for it. See what our users
              <br className="hidden md:block" /> are saying about their eeezo
              experience.
            </p>
          </div>

          <div
            ref={scrollReview}
            className="flex gap-4 mt-12 md:mt-16 overflow-x-auto no-scrollbar pb-2 px-2"
          >
            {reviews.map((review, index) => (
              <div
                key={index}
                className={`p-4 shadow-md rounded-lg w-full md:w-4/12 min-w-[280px] md:min-w-[380px] bg-white bg-opacity-50 transition-all ${
                  index === hoveredIndex ? "scale-105 shadow-lg" : "scale-100"
                }`}
              >
                <div className="flex gap-1">
                  {[...Array(5)].map((_, starIndex) => (
                    <FaStar
                      key={starIndex}
                      className={`w-5 md:w-6 h-5 md:h-6 ${
                        starIndex < review.rating
                          ? "text-[#FFB739]"
                          : "text-gray-300"
                      }`}
                    />
                  ))}
                </div>

                <p className="text-sm md:text-base mt-2">{review.review}</p>

                <div className="flex gap-2 mt-4 items-center">
                  <img
                    src={Person}
                    className="w-10 h-10 md:w-12 md:h-12 object-cover rounded-lg"
                    alt="User"
                  />
                  <div>
                    <p className="font-semibold">{review.name}</p>
                    <p className="text-xs md:text-sm text-gray-400">
                      {review.job}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="flex justify-center gap-4 mt-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="#059669"
              className="w-10 h-10 p-2 bg-[#F2F9F9] rounded-md rotate-180 hover:cursor-pointer"
              onClick={() => handleReviewScroll("left")}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 12h16m-6-6l6 6m-6 6l6-6"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="#059669"
              className="w-10 h-10 p-2 bg-[#F2F9F9] rounded-md hover:cursor-pointer"
              onClick={() => handleReviewScroll("right")}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 12h16m-6-6l6 6m-6 6l6-6"
              />
            </svg>
          </div>
        </div>

        <div className="px-12 pt-8 bg-black w-full grid gap-28">
          <div className="lg:flex">
            <div className="lg:w-1/3 grid gap-2 mb-4">
              <img src={eeezoLogo} className="w-36 h-10" />
              <p className="text-xs font-[300] text-gray-400">
                Eeezo is lorem ipsum dolor sit amet, consectetur adipiscing
                elit, sed do eiusmod tempor incididunt ut labore et dolore magna
                aliqua. Ut enim ad minim veniam, quis nostrud
              </p>
              <div className="flex gap-2">
                <img src={fblogo} className="w-6 h-6" />
                <img src={instalogo} className="w-6 h-6" />
                <img src={linkedinlogo} className="w-6 h-6" />
                <img src={twitterlogo} className="w-6 h-6" />
                <img src={youtubelogo} className="w-6 h-6" />
              </div>
            </div>

            <div className="lg:w-1/4 ml-auto">
              <p className=" text-white">Get in Touch with Us</p>
              <div className="flex">
                <img src={locmarker} className="w-6 h-6" />
                <p className="text-gray-400 text-sm  ml-2">Bengaluru,India</p>
              </div>
              <div className="flex">
                <img src={phonelogo} className="w-6 h-6" />
                <p className="text-gray-400 text-sm  ml-2">+123 345123 556</p>
              </div>
              <div className="flex">
                <img src={maillogo} className="w-6 h-6" />
                <p className="text-gray-400 text-sm  ml-2">support@eeezo.in</p>
              </div>
            </div>
          </div>
          <div className="flex justify-center">
            <p className="text-gray-400 mb-0">
              © 2024, Eeezo Limited. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
export default LandingPage;
